import { createContext, useState, useEffect } from 'react';
import api from '../api/api';

export const AuthContext = createContext();

// Perfil incompleto si falta cualquiera de estos tres campos
export const isProfileIncomplete = (user) =>
  !user?.first_name || !user?.last_name || !user?.username;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // identifier puede ser email o username
  const login = async (identifier, password) => {
    const res = await api.post('/auth/login', { identifier, password });

    const { token, user } = res.data;

    if (!token || !user) {
      throw new Error('Login inválido: token o user faltantes');
    }

    localStorage.setItem('token', token);

    // El login response trae los campos básicos del user (id, name, first_name,
    // last_name, username, email, role) — suficiente para evaluar isProfileIncomplete.
    // Si necesitáramos más campos (phone, dni, etc.) haríamos GET /users/me acá.
    setUser(user);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  // Recuperar sesión al recargar la página
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    api.get('/users/me', {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        setUser(res.data.user || res.data);
      })
      .catch(() => {
        logout();
      });
  }, []);

  return (
    // setUser expuesto para que CompleteProfilePage pueda refrescar el contexto
    // sin necesidad de re-login
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
